import {VscFile, VscFilePdf} from 'react-icons/vsc'
import {formatBytes} from '@/utils/helpers'
import {Avatar, Progress} from '@/components/ui'
import React, {useEffect, useRef, useState} from 'react'
import {MdShoppingCart} from 'react-icons/md'
import {Dialog} from '@/components/ui/Dialog'
import {HiOutlineMagnifyingGlassPlus} from 'react-icons/hi2'
import MiniAudioPlayer from '@/components/ui/MiniAudioPlayer'
import Marquee from '@/components/ui/Marquee'
import {AiOutlineQuestionCircle} from "react-icons/ai";
import {IconComponent} from "@/components/ui/MyIcon";

const FileIcon = ({children}) => {
    return <span className="text-3xl font-light">{children}</span>
}

const FileItem = (props) => {
    const {className, file, children, progress, uploading, onClick, ...rest} = props
    let {type, mime, name, size, image, url = '', subtitle = ''} = file || {}
    return (
        <div className={`${className}`} {...rest}>
            <div className="flex w-full" onClick={onClick}>
                <div className="upload-file-thumbnail shrink-0 relative">
                    <Thumbnail file={file}/>
                    {uploading && <Progress
                        className="!absolute top-[calc(100% - 25px)] right-[calc(100% - 25px)] !w-fit"
                        showInfo={false}
                        variant="circle"
                        width={50}
                        percent={progress}
                    />}
                </div>
                <div className="upload-file-info w-full me-1 gap-1">
                    <Marquee className="upload-file-name text-sm font-medium"
                             style={{overflowWrap: 'anywhere'}}>{name}</Marquee>
                    {subtitle && <span className="upload-file-size text-xs">{subtitle?.substring(subtitle?.length - 22, subtitle?.length)}</span>}
                    {size && <span className="upload-file-size text-xs overflow-hidden overflow-ellipsis">{formatBytes(size) || ''}</span>}
                </div>
            </div>
            {children}
        </div>
    )
}

function Thumbnail(props) {
    let {file, ...rest} = props
    let {type = '', mime, name, size, image, url, className, shape, icon} = file || {}
    type = type || mime
    image = image || url

    const [isDialogOpen, setDialogOpen] = useState(false)

    const [isPlaying, setIsPlaying] = useState(false)
    const audioRef = useRef()

    useEffect(() => {
        if (!audioRef.current) return

        const onPlay = () => setIsPlaying(true)
        const onPause = () => setIsPlaying(false)
        audioRef.current.addEventListener('play', onPlay)
        audioRef.current.addEventListener('pause', onPause)

        return () => {
            audioRef.current?.removeEventListener('play', onPlay)
            audioRef.current?.removeEventListener('pause', onPause)
        }
    }, [audioRef?.current])

    if (type?.split('/')?.[0] === 'image')
        return <>
            <Dialog
                className={'p-0'}
                contentClassName={'p-0 overflow-hidden'}
                isOpen={isDialogOpen}
                onClose={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setDialogOpen(false)
                }}
                onRequestClose={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setDialogOpen(false)
                }}
            >
                <img src={image || '/assets/img/placeholder.jpg'} className={'w-full'}/>
            </Dialog>
            <div className={'group relative'} onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setDialogOpen(true)
            }}>
                <Avatar
                    className={`upload-file-image avatar-circle vertical-middle ${className} cursor-pointer hover transition-opacity group-hover:opacity-80`}
                    src={image || '/assets/img/placeholder.jpg'}
                    shape={shape}
                />
                <HiOutlineMagnifyingGlassPlus className={'absolute top-4 left-4 transition-opacity opacity-0 group-hover:opacity-100'} color={'white'} size={20}/>
            </div>
        </>

    if (type?.split('/')?.[0] === 'audio')
        return <MiniAudioPlayer
            src={url}
            className={
                'z-10 top-[calc(100% - 25px)] right-[calc(100% - 25px)] !w-fit'
            }
            color={'white'}
            bg={'white'}
            size={42}
        />


    if (type === 'order')
        return <FileIcon>
            <MdShoppingCart/>
        </FileIcon>

    if (type === 'faq')
        return <FileIcon>
            <AiOutlineQuestionCircle/>
        </FileIcon>


    if (type === 'application/pdf')
        return <FileIcon>
            <VscFilePdf/>
        </FileIcon>

    if (type === 'application/pdf')
        return <FileIcon>
            <VscFilePdf/>
        </FileIcon>


    return <FileIcon>
        {<IconComponent {...props} icon={icon}/> || <VscFile/>}
    </FileIcon>

}

FileItem.displayName = 'UploadFileItem'

export default FileItem
